import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { fetchMe, login as apiLogin, logout as apiLogout, onUnauthorized } from '../services/api';
import { resetGenerations } from '../services/generationStore';

const AuthContext = createContext(null);

/** Текущий пользователь, вход/выход и обновление профиля (очки, квота) после действий. */
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await fetchMe();
      setUser(res.data);
    } catch {
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => onUnauthorized(() => { setUser(null); resetGenerations(); }), []);

  const signIn = useCallback(async (username, password) => {
    const res = await apiLogin(username, password);
    setUser(res.data);
    return res.data;
  }, []);

  const signOut = useCallback(async () => {
    try { await apiLogout(); } catch { /* сессия могла истечь */ }
    setUser(null);
    resetGenerations();                     // задачи и черновики не должны достаться следующему за компьютером
  }, []);

  const value = useMemo(() => ({ user, loading, signIn, signOut, refresh: load }),
    [user, loading, signIn, signOut, load]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth вне AuthProvider');
  return ctx;
}
